export const CertificateSpecializationModel =  [
    {
        credentialId: "DPPD3GVWZY6P",
        credentialUrl: "https://www.coursera.org/account/accomplishments/specialization/DPPD3GVWZY6P",
        instructor: "Meta",
        issuedDate: new Date("2023-11-01"),
        issuedOrganization: "Coursera",
        name: "Meta iOS Developer"
    },  {
        credentialId: "LL23VAKQ5DD5",
        credentialUrl: "https://www.coursera.org/account/accomplishments/specialization/certificate/LL23VAKQ5DD5",
        instructor: "Meta",
        issuedDate: new Date("2024-03-29"),
        issuedOrganization: "Coursera",
        name: "Meta Android Developer"
    }
]
